<template>
   <div class="lds-dual-ring"></div>
</template>

<style scoped>
   .lds-dual-ring {
      display: inline-block;
      width: 80px;
      height: 80px;
   }
   .lds-dual-ring:after {
      content: " ";
      display: block;
      width: 64px;
      height: 64px;
      margin: 8px;
      border-radius: 50%;
      border: 6px solid rgb(239, 251, 247);
      border-color: rgb(239, 251, 247) transparent rgb(239, 251, 247) transparent;
      animation: lds-dual-ring 1.2s linear infinite;
   }
   @keyframes lds-dual-ring {
      0% {
         transform: rotate(0deg);
      }
      100% {
         transform: rotate(360deg);
      }
   }
</style>